import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import './Album.css';
import API from '../lib/API';
import Utils from '../lib/Utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight, faFile, faCheckCircle} from "@fortawesome/free-regular-svg-icons";
import { faExternalLinkAlt, faFilePdf, faSpinner, faDownload, faArrowCircleRight, faXmark} from "@fortawesome/free-solid-svg-icons";
import PDFDialog from './PDFDialog';
import OrderConfirmDialog from './OrderConfirmDialog';
import ProofreadSVG from './ProofreadIcon/ProofreadSVG';

class Album extends React.Component {
  state = {
    loading: '読み込み中',
    selectedOriuq: null,
    data:null,

    proofPDFLoading: true,
    proofPDFList : [],

    selectedPdfs: [],

    assistDialog: false,
    orderConfirmDialog: false,
    memoDialog: false,
    memoLoading: false,
  }
  loadingPDF = null;
  errorPDF = null;

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props.albumCode !== prevProps.albumCode) {
      if (this.props.albumCode) {
        this.loadAlbum();
      }
    }
  }

  loadAlbum = () => {
    let pdfLoadState = this.props.showPDFAuthority.hasAny ? true : false;
    this.setState({
      loading:'読み込み中', 
      selectedOriuq:null,
      proofPDFLoading: pdfLoadState, 
      proofPDFList:[],
      selectedPdfs:[],
      assistDialog:false,
    });
    API.getAlbum(this.props.albumCode)
      .then((data)=>{
        if (data.code !== this.props.albumCode) return;
        this.setState({
          loading:null,
          data: data,
        });

        if (this.props.showPDFAuthority.hasAny) {
          this.loadProofPDF();
        }
      });
  }
  loadProofPDF = () => {
    if (!this.state.data || !this.state.data.oris) return null;
    let pageKeys = this.state.data.oris.reduce((carry, ori)=>{
      if (['校正中','校了'].indexOf(ori.status) >= 0) {
        carry.push({
          oriuq: ori.oriuq,
          pageKey: ori.pageKey
        });
      }
      return carry;
    }, []);
    API.listProofPDF(this.props.albumCode, pageKeys).then( (ret)=>{
      if (ret.code === this.props.albumCode.toString()) {
        this.setState({
          proofPDFList: ret.pdfList,
          proofPDFLoading: false
        });
      }
    }).catch(()=>{
      this.setState({proofPDFLoading: false});
    })
  }

  handleSelectOri = (e) => {
    this.setState({selectedOriuq: e.target.parentElement.dataset.oriuq});
  }

  handleProofread = (e) => {
    e.stopPropagation();
    let tr = e.target.closest('tr');
    //var ori = parseInt(tr.dataset.oriuq.replace(this.props.albumCode,''),10);
    window.open('/proofread/'+tr.dataset.oriuq, '_blank');
  }

  handleShowPDF = (e) => {
    e.stopPropagation();
    let tr = e.target.closest('tr');
    let name = this.state.data.info.hinmei + 'P' +  tr.querySelector('.pageName .numbre').innerText + '.pdf';
    let w = window.open('/pdfjs/web/viewer.html?file=null&filename='+encodeURIComponent(name)+'&file='+this.getLoadingPDF(), name);
    window.focus();
    API.getProofPDF(tr.dataset.oriuq).then((result)=>{
      //console.log(result.props)
      var pageText = result.props.PageText || 'P' + tr.querySelector('.pageName .numbre').innerText;
      var created = result.props.PDFFileCreated.replace(/\D/g, '');
      name = this.state.data.info.hinmei + pageText +'_'+ created + (result.props.OriStatus ? ('_'+result.props.OriStatus):'') + '.pdf';
      
      const fileUrl = URL.createObjectURL(result.blob);
      w.location.href = '/pdfjs/web/viewer.html?filename='+encodeURIComponent(name)+'&file='+fileUrl;
      w.focus();
      w.title = name;
    }).catch(()=>{
      w.location.href = '/pdfjs/web/viewer.html?filename='+encodeURIComponent(name)+'&file='+this.getErrorPDF();
    });
  }
  getLoadingPDF = () => {
    if (this.loadingPDF) return this.loadingPDF;
    this.loadingPDF = URL.createObjectURL(Utils.base64ToBlob('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'));
    return this.loadingPDF;
  }
  getErrorPDF = () => {
    if (this.errorPDF) return this.errorPDF;
    this.errorPDF = URL.createObjectURL(Utils.base64ToBlob('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'));
  }

  /****************************/
  /*    折一覧テーブル
  /****************************/
  createFlags = ori => {
    let flags = [];
    if (['表紙','ケース'].indexOf(ori.pageName) < 0 && ori.service) flags.push(<span className="flag flag-service" title="レイアウトサービス" key="layoutservice">レ</span>);
    if (ori.assist) flags.push(<span className="flag flag-assist" title="アシスト" key="assist"></span>);
    if (ori.bessatu) flags.push(<span className="flag flag-bessatu" title="別冊" key="bessatu">別</span>);
    if (ori.masuzuri) flags.push(<span className="flag flag-masuzuri" title="増刷" key="masuzuri">増</span>);
    return flags;
  }
  createOriTable = () => {
    if (!this.state.data || !this.state.data.oris) return null;
    let maxReKosei = this.state.data.oris.reduce((carry, ori) => {
      let koseiLength = ori.kosei.length;
      if (ori.hasOwnProperty('proofScheduleDate')) koseiLength++;
      return Math.max(carry, koseiLength);
    }, 0);

    let headers = (
      <tr>
        <th className="proofread">校正</th>
        <th className="pageName">頁</th>
        <th className="flags"></th>
        <th className="naiyou">内容</th>
        <th className="status">状態</th>
        <th className="nyuko">入稿日</th>
        {
          [...Array(maxReKosei)].map((_, i) => {
            let title = '初校';
            if (i >= 1) {
              let noma = '々'.repeat(i-1);
              title = `再${noma}校`
            }
            return (<th className={"kosei"+i} key={i}>{title}</th>)
          })
        }
      </tr>
    );
    
    return (
      <table>
        <thead>{headers}</thead>
        <tbody onClick={this.handleSelectOri}>
          {
            this.state.data.oris.map(ori => {
              let proofScheduleDate = '';
              return (
                <tr key={ori.oriuq} data-oriuq={ori.oriuq} data-status={ori.status}
                  className={this.state.selectedOriuq === ori.oriuq ? "selected" : ""}
                  >
                  <td className="proofread">{this.createProofreadStatus(ori)}</td>
                  <td className="pageName">
                    <span className="numbre">{ori.pageName}</span>
                    {
                      parseInt(ori.pages2,10) > 0
                      ? <span className="numbre1" title="第一ノンブル">[第一： {parseInt(ori.pages1,10)+' - '+parseInt(ori.pagee1,10)}]</span>
                      : null
                    }
                  </td>
                  <td className="flags">{this.createFlags(ori)}</td>
                  <td className="naiyou">{ori.naiyou}</td>
                  {(()=>{
                    if (ori.hasOwnProperty('proofScheduleDate') && proofScheduleDate === '') {
                      proofScheduleDate = ori.proofScheduleDate;
                      return (<td className="status Album-PageList-ProofScheduleDate">
                        <span>
                          <div className="title">校正出予定日</div>
                          <div className="date">{Utils.hyphenationToDate(ori.proofScheduleDate)}</div>
                        </span>
                        </td>
                      )
                    }
                    if (['表紙', 'ケース'].indexOf(ori.pageName) >= 0 ) return (<td className="status">{ori.status.length > 0 ? ori.status : ''}</td>);
                    return (<td className="status">{ori.status}</td>);
                  })()}
                  <td className="nyuko">{Utils.numberToDate(ori.nyukobi)}</td>
                  {
                    [...Array(maxReKosei)].map((_, i) => {
                      let start = ori.kosei.length > i && ori.kosei[i].start > 0 ? ori.kosei[i].start : '';
                      let stop  = ori.kosei.length > i && ori.kosei[i].stop  > 0 ? ori.kosei[i].stop  : '';
                      if (start) {
                        return (<td className={"kosei"+i} key={i}>
                          <span className="Album-PageList-KoseiStart" key="1">{Utils.numberToDate(start)}</span>
                          <span className="Album-PageList-KoseiStop" key="2">{Utils.numberToDate(stop)}</span>
                          </td>
                        )
                      }
                      else {
                        return <td className={"kosei"+i} key={i}></td>
                      }
                    })
                  }
                </tr>
              )
            })
          }
        </tbody>
      </table>
    )

  }

  createProofreadStatus = ori => {
    if (['表紙', 'ケース'].indexOf(ori.pageName) < 0  && ori.service && !ori.nyukobi) { // レイアウトサービスの場合、入稿するまでPDFを表示
      return <FontAwesomeIcon className="proofPDFIcon proofPDFBtn" icon={faFilePdf} onClick={this.handleShowPDF} title="校正PDFの表示 "></FontAwesomeIcon>;
    }
    if (!ori.kosei || !ori.kosei[ori.kosei.length-1] || !ori.kosei[ori.kosei.length-1].olpr) {
      // pdf
      if (this.state.proofPDFLoading && (ori.status === '校正中' || ori.to_ctp)) return <FontAwesomeIcon className="proofPDFIcon proofPDFSpinner" icon={faSpinner}></FontAwesomeIcon>;
      if (!this.state.proofPDFLoading && (ori.status === '校正中' || ori.to_ctp) && this.state.proofPDFList && this.state.proofPDFList.hasOwnProperty(ori.oriuq) && ((this.props.showPDFAuthority.onProofing && ori.status === '校正中') || (this.props.showPDFAuthority.onFinProof && ori.to_ctp))) {
        return <FontAwesomeIcon className="proofPDFIcon proofPDFBtn" icon={faFilePdf} onClick={this.handleShowPDF} title="校正PDFの表示 "></FontAwesomeIcon>;
      }
      return null;
    }

    let kosei = ori.kosei[ori.kosei.length-1];
    let proofStatus = this.state.data.proofread.find(p=>{
      return p.oriuq === ori.oriuq && p.koseiStart === kosei.start;
    });

    let status = proofStatus ? proofStatus.status : '';
    switch (status) {
      case 'finish': 
      case 'noChangeFinish': 
        if (ori.to_ctp) return <ProofreadSVG className="proofreadStatus" style={{color:'blue'}} onClick={this.handleProofread}/>;
        return <ProofreadSVG className="proofreadStatus" style={{color:'gray'}} onClick={this.handleProofread}/>;
      case 'start': /* falls through */
      case 'retake': return <ProofreadSVG className="proofreadStatus" style={{color:'gray'}} onClick={this.handleProofread}/>;
      case 'stop': 
      default: return <ProofreadSVG className="proofreadStatus" style={{color:'red'}} onClick={this.handleProofread}/>;
    }
    
  }


  /****************************/
  /*    PDFテーブル
  /****************************/
  createPDFTable = () => {
    if (this.state.proofPDFLoading) return null;
    if (Object.keys(this.state.proofPDFList).length === 0) {
      return (<div className="Album-PDFDownLoad-NoPDFWrap">
        <div className="Album-PDFDownLoad-NoPDF">
          ダウンロードできるPDFはありません。
        </div>
      </div>)
    }
    return (<table onClick={this.handleClickPDFTable} ref={ref=>{this.pdfTbody=ref;}}>
      <thead>
        <tr>
          <th className="selectCell">{this.state.selectedPdfs.length}</th>
          <th>頁</th>
          <th className="naiyou">内容</th>
          <th className="created">PDF更新日時</th>
        </tr>
      </thead>
      <tbody>
        {
          this.state.data.oris.reduce((c,o)=>{
            if (this.state.proofPDFList.hasOwnProperty(o.oriuq)
              && ((this.props.showPDFAuthority.onProofing && o.status === '校正中') || (this.props.showPDFAuthority.onFinProof && o.to_ctp))
            ) {
              c.push(<tr key={o.oriuq} data-oriuq={o.oriuq} data-state={this.state.selectedPdfs.indexOf(o.oriuq) >= 0 ? 'selected' : 'canSelect'}>
                <td className="selectCell"><span>✔︎</span></td>
                <td className="pageName">
                  <span className="numbre">{o.pageName}</span>
                  {
                    parseInt(o.pages2,10) > 0
                    ? <span className="numbre1" title="第一ノンブル">[第一： {parseInt(o.pages1,10)+' - '+parseInt(o.pagee1,10)}]</span>
                    : null
                  }
                </td>
                <td className="naiyou">{o.naiyou}</td>
                <td className="created">{this.state.proofPDFList[o.oriuq].replace(/^\d{4}-0?(1?\d)-0?([1,2,3]?\d) 0?([1,2]?\d):0?([1-5]?\d):\d{2}$/, '$1月$2日 $3:$4')}</td>
              </tr>)
            }
            return c;
          }, [])
        }
      </tbody>
    </table>);
  }
  handleClickPDFTable = e => {
    let tr = e.target.closest('tr');
    if (!tr) return;
    let oriuq = tr.dataset.oriuq;
    let selectedPdfs = this.state.selectedPdfs;
    if (tr.dataset.state === 'canSelect') {
      selectedPdfs.push(oriuq);
      this.setState({selectedPdfs:selectedPdfs});
    }
    else if (tr.dataset.state === 'selected') {
      selectedPdfs.splice(selectedPdfs.indexOf(oriuq), 1);
      this.setState({selectedPdfs:selectedPdfs});
    }
  }
  handleClickPDFDownloadBtn = e => {
    e.preventDefault();
    if (e.target.classList.contains('Album-PDFDownload-ResetBtn')) {
      this.setState({ selectedPdfs: [] });
      return;
    }
    if (e.target.classList.contains('Album-PDFDownload-AllSelectBtn') && Object.keys(this.state.proofPDFList).length > 0) {
      this.setState({ selectedPdfs: Object.keys(this.state.proofPDFList) });
      return;
    }

   if (this.state.selectedPdfs.length === 0) return;
    
    this.setState({loading:'PDFダウンロードの準備中'});
    API.getProofPDFZip(this.state.selectedPdfs)
    .then(ret => {
      var link = document.createElement('a');
      document.body.appendChild(link);

      let year = parseInt(this.props.albumCode.substr(7), 10) + 1988;
      link.download = this.state.data.info.hinmei + '_' + year + '年度_' + (new Date()).toLocaleDateString('sv-SE') + '.zip';
      link.href = window.URL.createObjectURL(ret.blob);
      link.click();
      setTimeout(function() {
        window.URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      }, 5000);
      this.setState({loading:null});
    })
    .catch(err=>{
      console.log(err)
    })
    .finally(()=>{
      this.setState({loading:null});
    });
  }

  /****************************/
  /*    配送追跡リンクの生成
  /****************************/
  createTransporterTrackingLink = (t) => {
    let sendDate = Utils.YmdToDateObject(t.sendDate);
    let nowDate = new Date();

    switch (t.transporter) {
    case 'japanpost':
      nowDate.setDate(-100); // 郵便局は100日間
      if (sendDate < nowDate) return (<span className="overlimit">期限切れ</span>);
      return (<a href={`https://trackings.post.japanpost.jp/services/srv/search/?requestNo1=${t.ticketNumber}&search=追跡スタート`} target="_blank" rel="noopener noreferrer" title="郵便局の「郵便追跡サービス」を開きます。">配達状況照会<FontAwesomeIcon icon={faExternalLinkAlt}></FontAwesomeIcon></a>);
      
    case 'meitetsu':
      nowDate.setDate(-60);
      if (sendDate < nowDate) return (<span className="overlimit">期限切れ</span>);
      return (<form action="https://ap.meitetsuunyu.co.jp/webtrace/webtsuiseki/webtsuiseki.aspx" name="KantanForm" method="post"target="_blank" rel="noopener noreferrer" acceptCharset="shift_jis">
        <input style={{display:'none'}} name="searchkbn" type="hidden" value="okuri"/>
        <div style={{display:'none'}}>
          <input name="g01" type="text" defaultValue={t.ticketNumber} />
          <input name="g02"/>
          <input name="g03"/>
          <input name="g04"/>
          <input name="g05"/>
          <input name="g06"/>
          <input name="g07"/>
          <input name="g08"/>
          <input name="g09"/>
          <input name="g10"/>
        </div>
        <input type="hidden" name="referURL" defaultValue="https://www.meitetsuunyu.co.jp/" />
        <button value="&#xf35d;" type="submit" title="名鉄運輸の「お荷物の配送状況問合せ」を開きます。">配達状況照会<FontAwesomeIcon icon={faExternalLinkAlt}></FontAwesomeIcon>
        </button>
      </form>);
      
    
    case 'sagawa':
      nowDate.setDate(-60); // 佐川急便は60日間
      if (sendDate < nowDate) return (<span className="overlimit">期限切れ</span>);
      return (<a href={`http://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=${t.ticketNumber}`} target="_blank" rel="noopener noreferrer" title="佐川急便の「お荷物問い合わせサービス」を開きます。">配達状況照会<FontAwesomeIcon icon={faExternalLinkAlt}></FontAwesomeIcon></a>);
      
      
    case 'yamato':
      nowDate.setDate(-90); // ヤマト運輸はは90日間
      if (sendDate < nowDate) return (<span className="overlimit">期限切れ</span>);
      return (<a href={`http://jizen.kuronekoyamato.co.jp/jizen/servlet/crjz.b.NQ0010?id=${t.ticketNumber}`}target="_blank" rel="noopener noreferrer" title="ヤマト運輸の「荷物お問い合わせシステム」を開きます。">配達状況照会<FontAwesomeIcon icon={faExternalLinkAlt}></FontAwesomeIcon></a>);
      
      
    case 'nittora':
      nowDate.setDate(-60);
      if (sendDate < nowDate) return (<span className="overlimit">期限切れ</span>);
      return (<a href={`https://lp-trace.nittsu.co.jp/web/webarpaa702.srv?parm=&denpyoNo1=${t.ticketNumber}&denpyoNo6=&denpyoNo2=&denpyoNo7=&denpyoNo3=&denpyoNo8=&denpyoNo4=&denpyoNo9=&denpyoNo5=&denpyoNo10=`} target="_blank" rel="noopener noreferrer" title="日本通運の「配達状況確認」を開きます。">配達状況照会<FontAwesomeIcon icon={faExternalLinkAlt}></FontAwesomeIcon></a>);
    
    case 'fukuyama':
      nowDate.setDate(-60);
      if (sendDate < nowDate) return (<span className="overlimit">期限切れ</span>);
      return (<a href={`https://corp.fukutsu.co.jp/situation/tracking_no_hunt/${t.ticketNumber}`} target="_blank" rel="noopener noreferrer" title="福山通運の「お荷物配達状況照会」を開きます。">配達状況照会<FontAwesomeIcon icon={faExternalLinkAlt}></FontAwesomeIcon></a>);
    
    
    case 'tonami':
      nowDate.setDate(-90); // トナミ運輸は3ヶ月
      if (sendDate < nowDate) return (<span className="overlimit">期限切れ</span>);
      return (<a href={`https://trc1.tonami.co.jp/trc/search3/excSearch3?id[0]=${t.ticketNumber}`} target="_blank" rel="noopener noreferrer" title="トナミ運輸の「荷物お問合せシステム」を開きます。">配達状況照会<FontAwesomeIcon icon={faExternalLinkAlt}></FontAwesomeIcon></a>);
      
    default:
      return null;
    }
  }

  /****************************/
  /*    配送一覧
  /****************************/
  renderDelivery = () => {
    if (!this.state.data || this.state.data.delivery.length <= 0) {
      return null;
      /*
      return (<div className="Album-Delivery-emptyWrap">
        <div className="Album-Delivery-empty">
          <div className="Album-Delivery-empty-img"></div>
          <div className="Album-Delivery-empty-txt">出荷が開始されていません。</div>
        </div>
      </div>);
      */
    }
    return this.state.data.delivery.map((dlv, i) => {
      return (<div className="Album-Delivery-Item" key={i} data-indivisual={dlv.indivisual}>
        <div className="Album-Delivery-Row">
          <div className="Album-Delivery-Label">出荷日</div>
          <div className="Album-Delivery-Value">{Utils.YmdToJDate(dlv.sendDate) || '未設定'}</div>
        </div>
        <div className="Album-Delivery-Row">
          <div className="Album-Delivery-Label">到着予定日</div>
          <div className="Album-Delivery-Value">{Utils.YmdToJDate(dlv.receiveDate) || '未設定'}</div>
        </div>
        <div className="Album-Delivery-Row">
          <div className="Album-Delivery-Label">運送業者</div>
          <div className="Album-Delivery-Value">{dlv.transporterName}</div>
        </div>
        <div className="Album-Delivery-Row Album-Delivery-ReceiverName">
          <div className="Album-Delivery-Label">お届け先 名称</div>
          <div className="Album-Delivery-Value">{dlv.receiverName ? `${dlv.receiverName} 様` : ''}</div>
        </div>
        <div className="Album-Delivery-Row Album-Delivery-ReceiverAddress">
          <div className="Album-Delivery-Label">お届け先 住所</div>
          <div className="Album-Delivery-Value">{`〒${dlv.receiverZip} ${dlv.receiverAddress}`}</div>
        </div>
        <div className="Album-Delivery-Row Album-Delivery-ReceiverTel">
          <div className="Album-Delivery-Label">お届け先 電話番号</div>
          <div className="Album-Delivery-Value">{dlv.receiverTel}</div>
        </div>
        <div className="Album-Delivery-Row Album-Delivery-Indivisual">
          <div className="Album-Delivery-Label">個別配送</div>
          <div className="Album-Delivery-Value">✔︎</div>
        </div>
        <div className="Album-Delivery-Row Album-Delivery-Contents">
          <div className="Album-Delivery-Label">内容</div>
          <div className="Album-Delivery-Value">
            {dlv.honKazu  > 0 ? <span className="Album-Delivery-Content">アルバム {dlv.honKazu}冊</span> : null}
            {dlv.betuKazu > 0 ? <span className="Album-Delivery-Content">別冊 {dlv.betuKazu}冊</span> : null}
            {dlv.masuKazu > 0 ? <span className="Album-Delivery-Content">増刷 {dlv.masuKazu}枚</span> : null}
            {dlv.packTogethers ? <span className="Album-Delivery-Content">同梱物 {dlv.packTogethers}</span> : null}
          </div>
        </div>
        <div className="Album-Delivery-Row">
          <div className="Album-Delivery-Label">個口</div>
          <div className="Album-Delivery-Value">{dlv.numOfBoxes}</div>
        </div>
        {
          dlv.transporter !== 'take'
          ? (
            <div className="Album-Delivery-Row">
              <div className="Album-Delivery-Label">送り状番号</div>
              <div className="Album-Delivery-Value">{
                this.renderDeliveries(dlv)
              }</div>
            </div>
          )
          : null
        }
      </div>)
    });
  }
  renderDeliveries = (dlv) => {
    if (dlv.transport) {
      return (<div className="Album-Delivery-Tickets">{
        dlv.transport.map((t,i) => {
          return (
            <div className="Album-Delivery-Ticket" key={i}>{t.ticketNumber} {(this.createTransporterTrackingLink(t))}</div>
          )
        })
      }</div>)
    }
    else if (parseInt(dlv.indivisual,10) > 0) {
      return (<div className="Album-Delivery-Tickets-sorry">
        <div className="Album-Delivery-Tickets-sorry-img"></div>
        <div className="Album-Delivery-Tickets-sorry-txt">個別発送はこのシステムでは表示できません。<br/>別途、送り状番号をご連絡します。</div>
      </div>);
    }
    else if (dlv.sendDate === (new Date()).toLocaleDateString('sv-SE')) {
      return (<div className="Album-Delivery-Tickets-sorry">
        <div className="Album-Delivery-Tickets-sorry-img"></div>
        <div className="Album-Delivery-Tickets-sorry-txt">ただいま調査中です。<br/>しばらくお待ちください。</div>
      </div>);
    }
    else {
      return (<div className="Album-Delivery-Tickets-sorry">
        <div className="Album-Delivery-Tickets-sorry-img Album-Delivery-Tickets-sorry-img-2"></div>
        <div className="Album-Delivery-Tickets-sorry-txt">送り状番号を取得できませんでした。<br/>ご入用の際は、お問い合わせください。</div>
      </div>);
    }
  }


  onClickDocumentTable = e => {
    if (e.target.classList.contains('showDocumentPDF')) {
      let tr = e.target.closest('tr');
      if (!tr || tr.dataset.status === 'removed') return;
      this.setState({loading:'PDF読み込み中'});
      API.showDocumentPDF(tr.dataset.id)
      .then(blob=>{
        this.pdfDlg.open(blob);
      })
      .finally(()=>{
        this.setState({loading:null});
      })
    }
  }
  createDocument = (document_type) => {
    this.documentEditDlg.open(document_type, null);
  }

  /*********************************/
  /*    InfoButtonクリック
  /*********************************/
  handleClickInfoButtons = e => {
    if (e.target.classList.contains('Album-InfoButton-assist')) {
      e.preventDefault();
      if (this.state.data.assist.length === 0) return;
      if (this.state.data.assist.length === 1) {
        this.loginToAssist(this.state.data.assist[0].Username);
      }
      else {
        this.setState({assistDialog:true});
      }
    }
  }


  /*********************************/
  /*    アシストログインダイアログ
  /*********************************/
  renderAssistDialog = () => {
    return (
      <div className="AssistDialog dialog" onClick={this.handleClickAssistDialog}>
        <div className="AssistDialog-window dialog-window">
          <div className="AssistDialog-message dialog-message">ログインするアシストアカウントを選択してください。</div>
          <div className="AssistDialog-table dialog-main">
            <table>
              <thead>
                <tr>
                  <th>名前</th>
                  <th>アカウントID</th>
                  <th>-</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.data.assist.map((acc, i) => {
                    return (<tr key={i} data-assist-id={acc.Username}>
                      <td>{acc.AlbumName}</td>
                      <td>{acc.Username}</td>
                      <td className="AssistDialog-assistLogin"><span className="AssistDialog-assistLoginBtn"><FontAwesomeIcon icon={faArrowCircleRight}></FontAwesomeIcon>ログイン</span></td>
                    </tr>)
                  })
                }
              </tbody>
            </table>
          </div>
          <div className="AssistDialog-buttons dialog-buttons">
            <div className="AssistDialog-CancelButton dialog-button">閉じる</div>
          </div>
        </div>
      </div>
    )
  }
  handleClickAssistDialog = e => {
    if (e.target.classList.contains('AssistDialog-assistLoginBtn')) {
      this.loginToAssist(e.target.closest('tr').dataset.assistId);
      this.setState({assistDialog:false});
    }
    else if (e.target.classList.contains('AssistDialog-CancelButton')) {
      this.setState({assistDialog:false});
    }
  }
  loginToAssist = (assistId) => {
    let assistWin = window.open('');
    assistWin.document.head.innerHTML = `
      <style>
      body {
        background-color: #8bbabd;
      }
      .PageLoader {
        position: fixed;
        left:0;
        top:0;
        right:0;
        bottom:0;
        background-color: rgba(0,0,0,0.6);
      }
      .PageLoader-message {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 30px;
        white-space: nowrap;
        color: #fff;
      }
      .PageLoader-centering {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .PageLoader-anime:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        width: 300px;
        height: 300px;
        margin-top: -150px;
        margin-left: -150px;
        border-radius: 50%;
        border: 10px solid rgba(255,255,255,0.3);
        box-shadow: 0px 0px 2px #fff;
      }
      .PageLoader-anime:after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        width: 300px;
        height: 300px;
        margin-top: -150px;
        margin-left: -150px;
        border-radius: 50%;
        border-top: 10px solid #fff;
        border-right: 10px solid #fff;
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
        -webkit-animation: spinner 1.4s linear infinite;
        animation: spinner 1.4s linear infinite;
        box-shadow: 0px 0px 2px #fff inset;
      }
      @keyframes spinner {
        to {transform: rotate(360deg);}
      }
      </style>
    `;
    assistWin.document.body.innerHTML = `
      <div class="PageLoader">
        <div class="PageLoader-centering">
          <div class="PageLoader-anime"></div>
          <div class="PageLoader-message">Assist ログイン中</div>
        </div>
      </div>
    `;
    assistWin.document.title = 'Assist ログイン中';
    API.loginToAssist(assistId)
    .then(url => {
      assistWin.location.href = url;
    });
  }

  /****************************/
  /*    仕様確認
  /****************************/
  loadOrderData = (callback) => {
    this.setState({loading:'読み込み中'});
    API.getOrder(this.props.albumCode)
      .then((orderConfirm)=>{
        let data = this.state.data;
        data.orderConfirm = orderConfirm;
        this.setState({
          loading:null,
          data: data
        }, ()=>{
          if (typeof callback === 'function') callback();
        });
      });
  }
  handleEditConfirm = () => {
    this.setState({orderConfirmDialog:true})
  }
  handleOrderConfirmDialogClose = (saved) => {
    if (saved) {
      let oldState = this.state.data.orderConfirm ? this.state.data.orderConfirm.status : 'noCheck';
      this.loadOrderData(() => {
        let newState = this.state.data.orderConfirm ? this.state.data.orderConfirm.status : 'noCheck';
        if (oldState !== newState) this.props.updateOrderConfirmStatus(this.props.albumCode, newState);
      });
    }
    this.setState({orderConfirmDialog:false});
  }
  renderOrderConfirmEdit = () => {
    return (
      <div className="Album-OrderConfirm-EditWrap" data-status={this.state.data.orderConfirm.status || 'noCheck'} onClick={this.handleEditConfirm}>
        <div className="Album-OrderConfirm-MessageWrap">
          <div className="Album-OrderConfirm-Message">{this.state.data.orderConfirm ? this.state.data.orderConfirm.message : ''}</div>
        </div>
        <div className="Album-OrderConfirm-Properties">
          {
            this.state.data.orderConfirm
            ? (
              <div className="Album-OrderConfirm-Properties-Left">
                <div>最終保存：</div>
                <div className="Album-OrderConfirm-Timestamp">{this.state.data.orderConfirm.timestamp}</div>
                <div className="Album-OrderConfirm-LastUsername">{this.state.data.orderConfirm.last_username ? (`${this.state.data.orderConfirm.last_username} 様`) : ''}</div>
              </div>
            )
            : null
          }
          <div className="Album-OrderConfirm-Status" onClick={this.handleEditConfirm}><FontAwesomeIcon icon={faCheckCircle}/></div>
        </div>
      </div>
    )
  }
  renderOrderConfirm() {
    return (
      <div className="Album-OrderConfirm-info">
        <div className="Album-OrderConfirm-info-left">
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">サイズ</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.size}
              <span className="Album-OrderConfirm-subvalue">縦 {this.state.data.info.height}mm × 横 {this.state.data.info.width}mm</span>
            </div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">綴　じ</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.toji}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">用　紙</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.yousi}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">表　紙</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.hyousi}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">表見返</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.omomi}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">裏見返</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.urami}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">ケース</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.case}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">ラベル</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.caselabel}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">台　紙</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.daisi}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">別　冊</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.bessatu}</div>
          </div>
        </div>

        <div className="Album-OrderConfirm-info-right">
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">学校納品数</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.kazu > 0 ? this.state.data.info.kazu : '-'}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">貴社納品数</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.yobi > 0 ? this.state.data.info.yobi : '-'}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">別冊数</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.betu > 0 ? this.state.data.info.betu : '-'}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">増刷数</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.masu > 0 ? this.state.data.info.masu : '-'}</div>
          </div>
          <div className="Album-OrderConfirm-row">
            <div className="Album-OrderConfirm-label">納品先</div>
            <div className="Album-OrderConfirm-value">{this.state.data.info.nohin}</div>
          </div>
        </div>

      </div>
    )
  }


  /*********************/
  /*    メモダイアログ
  /*********************/
  onClickMemo = () => {
    this.setState({memoLoading:'メモの読み込み中', memoDialog:true});
    API.getMemo(this.props.albumCode).then(ret=>{
      this.setState({memoDialog: ret.memo || true, memoLoading:false});
    });
  }
  renderMemoDialog = () => {
    return (
      <div className="MemoDialog dialog" onClick={this.handleClickMemoDialog}>
        <LoadingOverlay active={!!this.state.memoLoading} spinner text={this.state.memoLoading} className="MemoDialog-Loader">   
          <div className="MemoDialog-window dialog-window">
            <div className="MemoDialog-message dialog-message">貴社にのみご利用いただけるメモ欄です。（弊社、学校様には表示されません）</div>
            <div className="MemoDialog-editableArea dialog-main">
              <textarea defaultValue={this.state.memoDialog === true ? '' : this.state.memoDialog} ref={ref=>{this.memoTextara=ref;}}></textarea>
            </div>
            <div className="MemoDialog-buttons dialog-buttons">
              <div className="MemoDialog-CancelButton dialog-button">閉じる</div>
              <div className="MemoDialog-SaveButton dialog-button">保存</div>
            </div>
          </div>
        </LoadingOverlay>
      </div>
    )
  }
  handleClickMemoDialog = e => {
    if (e.target.classList.contains('MemoDialog-CancelButton')) {
      this.setState({memoDialog: false});
    }
    else if (e.target.classList.contains('MemoDialog-SaveButton')) {
      this.setState({memoLoading:'メモの保存中', memoDialog:true});
      API.saveMemo(this.props.albumCode, this.memoTextara.value).then(ret=>{
        let data = this.state.data;
        data.memo = ret;
        this.setState({memoDialog: false, memoLoading:false, data: data});
      });
    }
  }

  calcKoryoLimit = (koryLimit, nohinbi) => {
    let lim = parseInt(koryLimit, 10);
    let d = new Date(nohinbi.replace(/^(\d{4})(\d{2})(\d{2}).*$/, '$1-$2-$3'));
    let limDate = new Date(d.getTime() - (1000*60*60*24*lim));
    return (limDate.getMonth()+1) + '月' + limDate.getDate() + '日';
  }

  render() {
    if (!this.props.albumCode) {
      return <div className="Album"></div>;
    }
    return (
      <LoadingOverlay active={!!this.state.loading} spinner text={this.state.loading}>
        <div className="Album">
        {
          this.state.data
          ? (
          <div className="Album-Info">
            <div className="Album-InfoNameBlock">
              <div className="Album-CloseButton"><FontAwesomeIcon icon={faArrowAltCircleRight} onClick={this.props.close}/></div>
              <div className="Album-InfoName">
                <div className="Album-InfoFurigana">{this.state.data.info.furigana}</div>
                <div className="Album-InfoHinmei" title={this.state.data.info.hinmei}>{this.state.data.info.hinmei}</div>
                <div className="Album-InfoKazu">
                  <span>
                    <span className="title">学校納品数：</span>
                    <span className="value">{this.state.data.info.kazu}</span>
                  </span>
                  <span>
                    <span className="title">貴社納品数：</span>
                    <span className="value">{this.state.data.info.yobi}</span>
                  </span>
                  {
                    this.props.koryoLimit > 0 && parseInt(this.state.data.info.expectedDate, 10) > 0
                    ? (
                      <span className="koryoLimit">
                        <span className="title">校了期限：</span>
                        <span className="value">{this.calcKoryoLimit(this.props.koryoLimit, this.state.data.info.expectedDate)}</span>
                      </span>
                    )
                    : null
                  }
                </div>
              </div>
            </div>
            <div className="Album-InfoButtons" onClick={this.handleClickInfoButtons}>
              <button className={"Album-InfoButton Album-InfoButton-assist" + (this.state.data.assist.length === 0 ? ' Album-InfoButton-Disable' : '')}
                title="アシストにログイン">アシスト</button>
              <a className={"Album-InfoButton Album-InfoButton-kaolabo" + (this.state.data.kaolabo ? '' : ' Album-InfoButton-Disable')}
                href="https://kaolabo.myassist.jp/"
                target="_blank" rel="noopener noreferrer" title="かおラボのログイン画面を開く">かおラボ</a>
              <a className="Album-InfoButton Album-InfoButton-hakuraku" 
                href={"https://hakuraku.myassist.jp/?title="+encodeURIComponent(this.state.data.info.hinmei)} 
                target="_blank" rel="noopener noreferrer" title="箔らくで表紙の作成">箔らく</a>
              {/*
              <a className="Album-InfoButton Album-InfoButton-proofread" 
                href={`/proofread/${this.props.albumCode}`} 
                target="_blank" rel="noopener noreferrer" title="オンライン校正画面を開く">オンライン校正</a><a className="Album-InfoButton Album-InfoButton-photoAssist"
                href="https://www.go-photoassist.com/"
                target="_blank" rel="noopener noreferrer" title="フォトアシストのログイン画面を開く">フォトアシスト</a>*/}
            </div>
          </div>
          )
          : null
        }
        {
          this.state.data
          ? (
          <div className="Album-Tabs">
            <input type="radio" className="Album-Tab" name="Album-Tab" id="Album-Tab-OrderComfirm"/><label htmlFor="Album-Tab-OrderComfirm">仕様確認</label>
            <input type="radio" className="Album-Tab" name="Album-Tab" id="Album-Tab-PageList" defaultChecked="checked"/><label htmlFor="Album-Tab-PageList">進捗</label>
            {!this.props.showPDFAuthority.hasAny ? null
              : [<input key={1} type="radio" className="Album-Tab" name="Album-Tab" id="Album-Tab-PDFDownload"/>,<label key={2} htmlFor="Album-Tab-PDFDownload">PDFダウンロード</label>]}
            <input type="radio" className="Album-Tab" name="Album-Tab" id="Album-Tab-Document"/><label htmlFor="Album-Tab-Document">アカウント<br/>発行済書類</label>
            <input type="radio" className="Album-Tab" name="Album-Tab" id="Album-Tab-Memo"/><label htmlFor="Album-Tab-Memo">メモ</label>

            <div className="Album-TabContent Album-TabContent-PageList">
              <div className="Album-PageList-TableWrap">
              {
                this.createOriTable()
              }
              </div>
            </div>

            <div className="Album-TabContent Album-TabContent-PDFDownload">

              <LoadingOverlay active={!this.state.loading && this.state.proofPDFLoading} spinner text={"読み込み中"} className="Album-PDFDownload-Loader">
                <div className="Album-PDFDownload-Header">
                  { this.state.selectedPdfs.length > 0
                    ? (<button className="Album-PDFDownload-Button Album-PDFDownload-ResetBtn" onClick={this.handleClickPDFDownloadBtn}><FontAwesomeIcon icon={faXmark}></FontAwesomeIcon>選択の解除</button>)
                    : (<button className="Album-PDFDownload-Button Album-PDFDownload-AllSelectBtn" onClick={this.handleClickPDFDownloadBtn} disabled={Object.keys(this.state.proofPDFList).length <= 0}>
                      <FontAwesomeIcon icon={faCheckCircle}></FontAwesomeIcon>すべて選択</button>)
                  }
                  <button className="Album-PDFDownload-Button Album-PDFDownload-DownloadBtn" onClick={this.handleClickPDFDownloadBtn} disabled={this.state.selectedPdfs.length <= 0}
                    ><FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>ダウンロード</button>
                    {/*}
                  <button className="Album-PDFDownload-Button Album-PDFDownload-AllDownloadBtn" onClick={this.handleClickPDFDownloadBtn} disabled={this.state.proofPDFOriuqs.length <= 0}
                    ><FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>すべてダウンロード</button>
                */}

                  <div className="message">
                    <p>ダウンロードするPDFを選択してください。</p>
                  </div>
                </div>
                <div className="Album-PDFDownload-TableWrap">
                {
                  this.createPDFTable()
                }
                </div>
              </LoadingOverlay>
            </div>

            <div className="Album-TabContent Album-TabContent-Document">
              <div className="Album-Document-DocList">
                <table>
                  <thead>
                    <tr>
                      <th>状態</th>
                      <th>内容</th>
                      <th>タイプ</th>
                      <th>発行書表示</th>
                    </tr>
                  </thead>
                  <tbody onClick={this.onClickDocumentTable}>{
                    this.state.data.document
                    ? this.state.data.document.sort((d1, d2)=>{
                      if (d1.status === d2.status) return d1.update_date > d2.update_date ? 1 : -1;
                      if (d1.status === 'removed') return 1;
                      if (d2.status === 'removed') return -1;
                      return 0;
                    }).map(doc=> {
                      return (<tr key={doc.id} data-id={doc.id} data-status={doc.status}>
                        <td className="status">{doc.statusname}</td>
                        <td className="filename">{doc.filename}</td>
                        <td className="typename">{doc.typename}</td>
                        <td className="showDocumentPDF"><FontAwesomeIcon icon={faFile}></FontAwesomeIcon></td>
                      </tr>)
                    })
                    : null
                  }</tbody>
                </table>
              </div>
            </div>


            <div className="Album-TabContent Album-TabContent-OrderComfirm">
              {this.props.orderConfirm ? this.renderOrderConfirmEdit():null}
              {this.renderOrderConfirm()}
              {this.renderDelivery()}
            </div>

            <div className="Album-TabContent Album-TabContent-Memo">
              <div className="Album-Memo-Message">貴社にのみご利用いただけるメモ欄です。（弊社、学校様には表示されません）<button className="Album-Memo-EditButton" onClick={this.onClickMemo}>メモの編集</button></div>
              <div className="Album-Memo-EditableArea" onClick={this.onClickMemo} title="メモの編集">{this.state.data && this.state.data.memo ? this.state.data.memo.memo : ''}</div>
            </div>
          </div>
          )
          : null
        }
        </div>
       
        <PDFDialog ref={ref=>{this.pdfDlg=ref;}} />

        {
          this.state.assistDialog
          ? this.renderAssistDialog()
          : null
        }
        {
          this.state.orderConfirmDialog
          ? <OrderConfirmDialog
              name={this.state.data ? this.state.data.info.hinmei : ''} albumCode={this.props.albumCode}
              close={this.handleOrderConfirmDialogClose}></OrderConfirmDialog>
          : null
        }
        {
          this.state.memoDialog
          ? this.renderMemoDialog()
          : null
        }
        
      </LoadingOverlay>
    );
  }
}
export default Album;